/**
 * AwaitingSageAccountBadge — the "Unknown customer" draft marker.
 *
 * Merlin drafted the order but found no Sage account for the buyer, so the
 * draft carries a proposed_new_customer block and no customer_no. It cannot
 * be submitted until the desk creates the account; the hourly relink sweep
 * binds it automatically once the customers row appears (kanban c797ddbb).
 * Without this marker the row reads as unactionable noise next to the
 * rep's other drafts and gets skipped (KRUEG01 "Trial Drum" sat 8 days).
 */
import { isAwaitingSageAccount, type OrderRecord } from '../../types/orders';

interface AwaitingSageAccountBadgeProps {
  order: Pick<OrderRecord, 'id' | 'status' | 'customer_no' | 'llm_extraction_data'>;
}

export default function AwaitingSageAccountBadge({ order }: AwaitingSageAccountBadgeProps) {
  if (!isAwaitingSageAccount(order)) return null;
  const proposed = order.llm_extraction_data?.proposed_new_customer;
  const where = [proposed?.city, proposed?.state].filter(Boolean).join(', ');
  const title =
    `No Sage account yet for "${proposed?.name ?? 'the proposed customer'}"` +
    `${where ? ` (${where})` : ''}. Create it in Sage (the order modal prefills it) ` +
    'and the draft re-links automatically within the hour, or dismiss the draft if the order was keyed another way.';
  return (
    <span
      data-testid={`awaiting-account-badge-${order.id}`}
      title={title}
      style={{
        background: '#fff7ed',
        color: '#9a3412',
        border: '1px solid #fdba74',
        borderRadius: '4px',
        padding: '1px 6px',
        fontSize: '10px',
        fontWeight: 700,
        whiteSpace: 'nowrap',
        letterSpacing: '0.02em',
      }}
    >
      AWAITING SAGE ACCOUNT
    </span>
  );
}
